import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { Statuses } from 'flow/types/Extension';
import { ActiveProfile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import AgentActivityWrapper from 'flow/components/pbx/supervisor/AgentActivityWrapper';
import ExtensionContactAvatar from 'flow/components/ui-components/ExtensionContactAvatar';
import ExtensionName from 'flow/components/ui-components/ExtensionName';

interface Props {
    extensionKey: ExtensionKey;
    agentStatus: Statuses;
    profileCurrent: TypedMap<ActiveProfile>;
    profileEndTime?: number;
    displayedInPopover?: boolean;
}

const AgentInfoContainer = ({
    extensionKey,
    agentStatus,
    profileCurrent,
    profileEndTime,
    displayedInPopover,
}: Props) => {
    // A note on this:
    // We first had the top div looking like this:
    // <div className={twMerge('flex w-full', displayedInPopover ? '' : '@container')}>
    // and the div where lg:flex-row and lg:items-center are specified, having the
    // @ prefix, i.e., @lg:flex-row and @lg:items-center, to respond to the width of the div
    // rather than that of the whole screen size.
    // This seemed to work fine, but we discovered that in the Electron (Desktop) version of the app,
    // the popover in AgentActivityWrapper (SimplePopover) melted into the background (but only when expanding downwards).
    // To be tested again some time when the Electron version is updated, and thus the Chromium version in use.

    return (
        <div className="flex w-full">
            <div className="size-10 items-center">
                <ExtensionContactAvatar
                    extensionKey={extensionKey}
                    status={agentStatus}
                    size={'toolbar'}
                />
            </div>
            <div
                className={twMerge(
                    'flex h-full w-full flex-col flex-wrap gap-x-3 gap-y-1 ps-3',
                    displayedInPopover
                        ? ''
                        : 'justify-between lg:flex-row lg:items-center',
                )}
            >
                <div className="h-5 truncate text-base/5 text-gray-800">
                    <ExtensionName extensionKey={extensionKey} />
                </div>
                <AgentActivityWrapper
                    extensionKey={extensionKey}
                    agentStatus={agentStatus}
                    profileCurrent={profileCurrent}
                    profileEndTime={profileEndTime}
                    useAgentQueueStatusTooltip={true}
                />
            </div>
        </div>
    );
};

export default React.memo(AgentInfoContainer);
